import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { show } from '@ebay/nice-modal-react';
import { Icon } from '@brandbank/portal-components';
import environmentVariables from 'config/environmentVariables';
import Widget from './Widget';
import { UserFeedbackModal } from 'features/user-feedback';

const NiqBrandbankContactInformation = (): JSX.Element => (
  <Widget title='NIQ Brandbank Contact Information'>
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Typography fontWeight={600} variant='h6'>
          Feed Information
        </Typography>

        <Typography>
          Have a query or issue regarding your existing feed, contact
          Integration Support.
        </Typography>

        <Link
          href={environmentVariables.integrationSupportUrl}
          sx={{ alignSelf: 'start', display: 'inline-flex', gap: 1 }}
          target='_blank'
          underline='hover'
        >
          <Icon iconName='open' />
          Integration Support
        </Link>
      </Stack>

      <Stack spacing={1}>
        <Typography fontWeight={600} variant='h6'>
          Feed Changes
        </Typography>

        <Typography>
          Want to make a change to your existing feed or want a new feed,
          contact our Pre-Sales Team.
        </Typography>

        <Link
          href={`mailto:${environmentVariables.preSalesEmail}`}
          sx={{ alignSelf: 'start', display: 'inline-flex', gap: 1 }}
          target='_blank'
          underline='hover'
        >
          <Icon iconName='email' />
          {environmentVariables.preSalesEmail}
        </Link>
      </Stack>

      <Stack spacing={1}>
        <Typography fontWeight={600} variant='h6'>
          Customer Integration Hub
        </Typography>

        <Typography>
          Have feedback or want to report an issue regarding the Customer
          Integration Hub, raise here.
        </Typography>

        <Link
          component='button'
          onClick={() => show(UserFeedbackModal)}
          sx={{ alignSelf: 'start' }}
          type='button'
          underline='hover'
        >
          Give feedback
        </Link>
      </Stack>
    </Stack>
  </Widget>
);

export default NiqBrandbankContactInformation;